<template>
    <div class="componente-principal">
        <br/>
        <botao 
            type="button" 
            font_awesome_class="far fa-calendar-alt" 
            label="Vencidos a mais de 30 dias"
            @click.native="vencidosMais30dias"/><br/>

        <botao 
            type="button" 
            font_awesome_class="far fa-calendar-alt" 
            label="Vencidos a menos de 30 dias"
            @click.native="vencidosMenos30dias"/><br/>

        <botao 
            type="button" 
            font_awesome_class="far fa-calendar-alt" 
            label="A vencer nos próximos 30 dias"
            @click.native="aVencerProximos30dias"/><br/>

        <botao 
            type="button"
            font_awesome_class="far fa-calendar-alt" 
            label="A vencer após 30 dias"
            @click.native="aVencerApos30dias"/><br/>


        
    </div>
</template>

<script>

import Botao from '@/components/shared/Botao.vue';
    
export default {
    name: 'ContasAPagar',
    props: ["tipocpcr"],
    components: {
        Botao
    },
    methods:{
        vencidosMais30dias(){
            this.$router.push(`/contasapagarreceber/${this.tipocpcr}/30DDmenos`);
        },
        vencidosMenos30dias(){
            this.$router.push(`/contasapagarreceber/${this.tipocpcr}/30Dmenos`);
        },
        aVencerProximos30dias(){
            this.$router.push(`/contasapagarreceber/${this.tipocpcr}/30Dmais`);
        },
        aVencerApos30dias(){
            this.$router.push(`/contasapagarreceber/${this.tipocpcr}/30DDmais`);
        }

    }

}
</script>

